import { VERIFY_EMAIL_SUCCESS, VERIFY_EMAIL_FAIL } from '../actions/actionTypes'

const initialState = {
  status: null,
  errorMessage: ''
}

function verifyEmailReducers(state = initialState, action) {
  switch (action.type) {
    case VERIFY_EMAIL_SUCCESS:
      return {...state, status: 'success'};
    case VERIFY_EMAIL_FAIL:
      return {...state, status: 'fail'};

    default:
      return state
  }
}

export default verifyEmailReducers;
